/** Word-level IPA overrides for Persian. */
export const fa: Record<string, string> = {
  آبِ: '/ɒːbe/',
  آرای: '/ɒːɾɒːj/',
  آفرین: '/ɒːfæɾiːn/', // creator
  آموی: '/ɒːmuːj/',
  آواره: '/ɒːvɒːɾe/', // wandering, exiled

  آوازه: '/ɒːvɒːze/', // fame, renown
  آیَد: '/ɒːjæd/',
  // --- Forough Farrokhzad, Another Birth ---
  آیه: '/ɒːje/', // verse (of scripture)
  ابدی: '/æbædiː/', // eternal
  ابوالفضل: '/æbolfæzl/',
  اجتماعی: '/ed͡ʒtemɒːʔiː/',
  ادر: '/ædeɾ/', // pour! (Arabic imperative)
  اساس: '/æsɒːs/',
  // --- Iranian Constitution ---
  اساسی: '/æsɒːsiː/',
  اصول: '/osuːl/',
  افتاد: '/oftɒːd/', // fell, befell
  // --- UDHR Article 1 ---
  افراد: '/æfɾɒːd/', // individuals

  اقتصادی: '/eɢtesɒːdiː/',
  // --- Hafez, Divan (Ghazal 1) ---
  الا: '/ælɒː/', // O! behold
  الساقی: '/æssɒːɢiː/', // the cupbearer (Arabic definite)
  اللّه: '/ællɒːh/',
  اندرش: '/ændæɾæʃ/', // within it
  انزوا: '/enzevɒː/', // seclusion
  انعکاس: '/enʔekɒːs/',
  // --- Sepehri ---
  اهل: '/æhl/',
  ای: '/ej/', // O! (vocative)
  ایها: '/æjjohɒː/', // O! (Arabic vocative)
  بادهای: '/bɒːdhɒːje/', // winds (with ezafeh)
  'ببریده\u200Cاند': '/bobɾiːdeænd/', // they have cut
  // --- Baba Taher ---
  ببندم: '/bebændæm/',
  بتابد: '/betɒːbæd/', // will shine
  بجان: '/bed͡ʒɒːn/',

  // --- Attar, Conference of the Birds ---
  بخشید: '/bæxʃiːd/',
  بدار: '/bedɒːɾ/',
  بداشت: '/bedɒːʃt/',
  برتر: '/bæɾtæɾ/', // higher, superior
  برد: '/boɾd/', // will carry (subjunctive)
  بستند: '/bæstænd/',
  بشاید: '/beʃɒːjæd/',
  بشر: '/bæʃæɾ/', // humankind
  // --- Rumi, Masnavi (Song of the Reed) ---
  بشنو: '/beʃno/', // listen!
  بشویم: '/beʃuːjæm/',
  بگردم: '/beɡæɾdæm/',
  بگشای: '/beɡoʃɒːj/',
  بگویم: '/beɡuːjæm/', // let me say
  بنازم: '/benɒːzæm/',
  // --- Saadi, Bustan ---
  بنام: '/benɒːm/', // in the name of
  بنشسته: '/beneʃæste/', // has sat
  بنمای: '/benæmɒːj/',

  // --- Rudaki ---
  بویِ: '/buːje/',
  بیهقی: '/bejhæɢiː/',
  پَرنیان: '/pæɾniːɒːn/',
  // --- Sanai ---
  پرور: '/pæɾvæɾ/',
  پستی: '/pæstiː/',
  'پوزش\u200Cپذیر': '/puːzeʃpæziːɾ/', // excuse-accepting
  تاریکیست: '/tɒːɾiːkiːst/', // is a darkness (contraction)
  تحقیق: '/tæhɢiːɢ/',
  توفیق: '/toʊfiːɢ/',

  'جدایی\u200Cها': '/d͡ʒodɒːjiːhɒː/', // separations
  جل: '/d͡ʒæll/', // majesty
  جوابِ: '/d͡ʒævɒːbe/',
  جویِ: '/d͡ʒuːje/',
  حافظ: '/hɒːfez/',
  حال: '/hɒːl/', // state, condition

  حالی: '/hɒːliː/', // pleasant (archaic: now)
  حقوق: '/hoɢuːɢ/', // rights
  حکیم: '/hækiːm/', // wise
  حیات: '/hæjɒːt/', // life

  حیثیت: '/hejsiːjæt/', // dignity
  // --- Nezami, Khosrow o Shirin ---
  خداوندا: '/xodɒːvændɒː/',
  // --- Saadi, Golestan ---
  خدای: '/xodɒːj/', // God (with ezafeh)
  خردبخش: '/xeɾædbæxʃ/',
  خطابخش: '/xætɒːbæxʃ/', // sin-forgiving
  خِنگِ: '/xenɡe/',
  خوشا: '/xoʃɒː/',
  خوشخوان: '/xoʃxɒːn/', // sweet-singing
  // --- Behbahani ---
  خویش: '/xiːʃ/',

  خیزران: '/xiːzɾɒːn/', // bamboo
  دارای: '/dɒːɾɒːje/', // possessing
  دانند: '/dɒːnænd/', // they know
  درِ: '/dæɾe/',
  دُرشتی‌های: '/doɾoʃtiːhɒːje/',
  دریچه‌ی: '/dæɾiːt͡ʃeje/',
  دستگیر: '/dæstɡiːɾ/', // helper
  دلی: '/deli/',
  دوستانی: '/duːstɒːniː/',
  دیدار: '/diːdɒːɾ/',

  ذوقی: '/zoʊɢiː/',
  را: '/ɾɒː/', // object marker
  رازق: '/ɾɒːzeɢ/',
  'رستن\u200Cهای': '/ɾæstænhɒːje/', // growings (with ezafeh)
  رضی: '/ɾæziː/',
  رفتار: '/ɾæftɒːɾ/', // behavior
  ره: '/ɾæh/',
  رهِ: '/ɾæhe/',
  رهنمای: '/ɾæhnæmɒːj/', // guide
  روحیه: '/ɾuːhiːje/', // spirit, morale
  روزگارم: '/ɾuːzeɡɒːɾæm/',
  'روزی\u200Cده': '/ɾuːziːdeh/', // sustenance-giver
  ریگِ: '/ɾiːɡe/',
  زاییده: '/zɒːjiːde/', // born
  زبانی: '/zæbɒːniː/',
  // --- Hedayat, The Blind Owl ---
  'زخم\u200Cهایی': '/zæxmhɒːjiː/', // wounds (indefinite)
  زی: '/ziː/',
  زیْ: '/ziː/',
  'ساحل\u200Cها': '/sɒːhelhɒː/', // shores
  سبکباران: '/sæbokbɒːɾɒːn/', // light-laden ones
  سبکتگین: '/sobokteɡiːn/',
  سحرگاه: '/sæhæɾɡɒːh/', // dawn
  // --- Nezami, Layli o Majnun ---
  سرآغاز: '/særɒːɡɒːz/',
  سراید: '/soɾɒːjæd/',
  سلامی: '/sælɒːmiː/',
  // --- Khayyam, Rubaiyat ---
  سودا: '/soʊdɒː/', // passion, melancholy
  سیاسی: '/sijɒːsiː/',
  شادمان: '/ʃɒːdmɒːn/',
  شرح: '/ʃæɾh/', // explanation
  شرحه: '/ʃæɾhe/', // explanation (with ezafeh)
  شکایت: '/ʃekɒːjæt/', // complaint
  'شکفتن\u200Cها': '/ʃekoftænhɒː/', // blossomings
  صلتِ: '/seleːte/',
  صنع: '/sonʔ/',
  ضوابط: '/zævɒːbet/',
  طاعتش: '/tɒːʔætæʃ/', // his obedience
  عز: '/ʔæzz/', // glory
  عمر: '/omɾ/',
  عنه: '/ænho/',
  غازی: '/ɣɒːziː/',
  غایت: '/ɣɒːjæt/',
  غزل: '/ɣæzæl/',
  غزنوی: '/ɣæznæviː/',
  غزنی: '/ɣæzniː/',
  فراق: '/feɾɒːɢ/', // separation
  فرد: '/fæɾd/', // alone, single
  فرهنگی: '/færhænɡiː/',
  فرو: '/foɾuː/', // down
  فلک: '/fælæk/',
  قدک: '/ɢædæk/',
  قربت: '/ɢoɾbæt/', // nearness (to God)
  قصیده‌ای: '/ɢæsiːdeæj/',
  // --- Nima Yushij, The Phoenix ---
  ققنوس: '/ɢoɢnuːs/', // phoenix
  کآفرینت: '/kɒːfæɾiːnæt/',
  کارگشای: '/kɒːɾɡoʃɒːj/',
  کاسا: '/kæʔsɒː/', // a cup (Arabic accusative, Persianized)
  کاشانم: '/kɒːʃɒːnæm/',
  کاو: '/kɒːw/',
  کریم: '/kæɾiːm/', // generous
  // --- Ferdowsi, Shahnameh ---
  کز: '/kæz/', // contraction of که از (that from)
  کشیدم: '/keʃiːdæm/', // I drew (a sigh)
  کلام: '/kælɒːm/',
  کنان: '/konɒːn/', // doing (present participle suffix)
  کنم: '/konæm/',
  کنند: '/konænd/', // they do (subjunctive)
  گردابی: '/ɡeɾdɒːbiː/', // a whirlpool (indefinite)
  // --- Akhavan-Sales ---
  گفت: '/ɡoft/',
  گُل: '/ɡol/',
  گوید: '/ɡuːjæd/',
  // --- Beyhaqi ---
  گویندهٔ: '/ɡuːjændeje/',
  لغزان: '/læɣzɒːn/',
  مادری: '/mɒːdæɾiː/',
  مانده: '/mɒːnde/', // remaining
  ماهتاب: '/mɒːhtɒːb/', // moonlight
  مبین: '/mobæjjen/',
  محمود: '/mæhmuːd/',
  مده: '/mædeh/',
  مزید: '/mæziːd/', // increase
  مفرح: '/mofæɾɾeh/', // gladdening
  ممد: '/momedd/', // sustainer
  موجب: '/moʊd͡ʒeb/', // cause of
  مولیان: '/muːliːɒːn/',
  مونس: '/muːnes/',
  موهبت: '/moʊhebæt/', // gift, endowment
  'می\u200Cآید': '/miːɒːjæd/', // comes (up)
  'می\u200Cتراشد': '/miːtæɾɒːʃæd/', // scrapes, carves
  'می\u200Cخورد': '/miːxoɾæd/', // eats, erodes
  'می\u200Cرود': '/miːɾævæd/', // goes (down)
  'می\u200Cشوند': '/miːʃævænd/', // they become (passive)
  'می\u200Cکند': '/miːkonæd/', // does, is doing
  ناپسند‌م: '/nɒːpæsændæm/',
  ناخوب: '/nɒːxuːb/',
  ناصر: '/nɒːseɾ/',
  'نالیده\u200Cاند': '/nɒːliːdeænd/', // they have lamented
  نانی: '/nɒːniː/',
  ناولها: '/nɒːvelhɒː/', // pass it around
  نتواند: '/nætævɒːnæd/',
  نشاطِ: '/neʃɒːte/',
  نظامی: '/nezɒːmiː/',
  نظربازیا: '/næzæɾbɒːziːɒː/',
  نعمت: '/neʔmæt/', // blessing
  نفسی: '/næfæsiː/', // a breath (indefinite)
  نفیرم: '/næfiːɾæm/', // my wailing
  نگاهِ: '/neɡɒːhe/',
  نگذرد: '/næɡozæɾæd/', // does not pass
  نگه: '/neɡæh/',
  نمود: '/nemuːd/', // appeared, showed
  'نمی\u200Cشود': '/næmiːʃævæd/', // is not possible
  // --- Shared classical forms ---
  نهاد: '/nehɒːd/',
  نهادهای: '/næhɒːdhɒːje/',
  نوش: '/nuːʃ/', // drink!
  نیابد: '/næjɒːbæd/', // will not find
  نیارد: '/næjɒːɾæd/',
  نیستان: '/nejestɒːn/', // reed bed
  // --- Shamlou ---
  نیستی: '/niːstiː/',
  هایل: '/hɒːjel/', // terrifying
  هستند: '/hæstænd/', // they are
  هَمی: '/hæmiː/',
  هوشی: '/huːʃiː/',
  وجدان: '/ved͡ʒdɒːn/', // conscience
  ودیعت: '/vædiːæt/',
  وزش: '/væzeʃ/', // blowing
  وی: '/væj/',
  یادِ: '/jɒːde/',
  یارِ: '/jɒːɾe/',
  یافت: '/jɒːft/',
  یکدیگر: '/jekdiːɡæɾ/', // one another
};
